import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';

// Create a theme instance.
const theme = createTheme({
    palette: {
        primary: {
            main: '#000',
        },
        secondary: {
            main: '#11C84F',
        },
        error: {
            main: red.A400,
        },
    },
    typography: {
        fontFamily: ['samim'],
        fontSize: 18,
    },
    components: {
        // Name of the component
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: '#fcfcfc',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                // Name of the slot
                root: {
                    // Some CSS
                    fontSize: '2rem',
                    fontWeight: 'bold',
                },
            },
        },
        MuiInput: {
            styleOverrides: {
                root: {
                    textAlign: 'center',
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                select: {
                    paddingLeft: '2rem !important',
                    paddingRight: '0 !important',
                },
            },
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    right: 'auto !important',
                    left: '0 !important',
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    justifyContent: 'center',
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    textAlign: 'center',
                },
            },
        }, MuiMobileStepper: {
            styleOverrides: {
                dotActive: {
                    backgroundColor: '#11C84F',
                },
            },
        }
    },
});

export default theme;
